import * as React from "react";
import Spinner from '../../common/components/spinner/spinner';
import Translate from '../../common/functions/translate';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import { InputText } from 'primereact/inputtext';
import { UserChangePasswordModel } from '../../models/user/userChangePasswordModel';
import * as HelperFunctions from "../../common/functions/helperFunctions";
import LoginService from '../../services/loginService';
import MailService from '../../services/mailService';
import * as Constants from '../../common/constants';
import { EmailDataModel } from '../../models/emailDataModel';
import * as EmailFunctions from '../../common/functions/emailFunctions';
import Growl from '../../common/components/alertMessage/growl';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faPills } from '@fortawesome/free-solid-svg-icons';
import TextField from '@material-ui/core/TextField';
import GrowlContent from '../../common/components/alertMessage/growlContent';

interface IProps {
}

interface IState {
  isLoading: boolean;
  user: UserChangePasswordModel;
  mode: string;
}

class ForgotPasswordComponent extends React.Component<IProps, IState> {

  loginService = new LoginService();
  mailService = new MailService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      user: new UserChangePasswordModel(),
      mode: 'forgotPassword'
    };
  }

  componentDidMount() {

  }

  handleChange = (key, value) => {
    const user: UserChangePasswordModel = { ...this.state.user };
    user[key] = value;
    this.setState({ user: { ...user } });
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSendButton(e);
    }
  }

  isValidAddEditForm() {
    let message = '';

    if (!this.state.user.email || this.state.user.email.trim() == '') {
      message += Translate('Please enter Email') + '.';
    } else {
      if (!HelperFunctions.validateEmail(this.state.user.email)) {
        message += Translate('Please enter valid Email') + '.';
      }
    }

    if (message != '') {
      this.growl.show({ severity: 'error', summary: message });
    }

    return message == '';
  }

  handleSendButton = event => {
    event.preventDefault();

    if (!this.isValidAddEditForm()) return;

    this.setState({
      isLoading: true
    });

    const user = this.state.user;

    this.loginService.forgotPassword(user.email).then(
      (data: any) => {
        if (data) {
          this.setState({
            isLoading: false,
            mode: 'sendConfirmEmail'
          });
        }
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  public render() {
    const { isLoading, user, mode } = this.state;

    const forgotPasswordHtml =
      <>
        <div className="p-g p-fluid">
          <div className="p-g-12 p-md-6">
            <TextField
              name="email"
              label={Translate('Email')}
              type="email"
              value={user && user.email ? user.email : ""}
              onChange={(e) => this.handleChange('email', e.target['value'])}
              helperText={Translate('Please enter your email.')}
            />
          </div>
          <div className="p-g-12 p-md-6">
            <Button variant="contained" size="medium" color='primary' onClick={this.handleSendButton}
              style={{ marginBottom: '15px' }}>
              {Translate('Send')}
            </Button>
          </div>
        </div>

        {/* <div style={{ paddingLeft: '9px' }}>
          <Button label={Translate('Send')} onClick={this.handleSendButton} className="p-button-raised" style={{ marginRight: '10px' }} />
        </div> */}
      </>

    const sendConfirmEmailHtml =
      <>
        <GrowlContent variant="info" message={Translate('We have sent an E-mail to you.')} />
        <div style={{ marginTop: '20px' }}>
          {Translate('Please check your E-mail box and click on confirmation link to change your password.')}
        </div>
      </>

    let resultHtml;

    switch (mode) {
      case 'sendConfirmEmail':
        resultHtml = sendConfirmEmailHtml;
        break;
      default:
        resultHtml = forgotPasswordHtml;
    }

    return (
      <div className="app-content">

        {isLoading ? <Spinner /> : null}
        <Growl ref={(el) => this.growl = el} />

        <h1>{Translate('Forgot password?')}</h1>

        <div>
          {resultHtml}
        </div>
      </div>
    )
  }
}

export default ForgotPasswordComponent;